<script type="ts">
	import { onMount } from 'svelte';
	import Time from 'svelte-time';
	import { get } from 'svelte/store';
	import Button from '../shared/Button.svelte';
	import { storeSettings } from '../../store/StoreSettings';

	const publicKey = get(storeSettings).publicKey;
	const buttonText = get(storeSettings).buttonText;
	const membershipCode = get(storeSettings).membershipCode;

	let loading = false;

	let membership: any = [];
	onMount(async () => {
		const res = await fetch(`API_URL/membershipType/${membershipCode}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				publicKey: publicKey
			}
		});
		membership = await res.json();
		console.log(membership);
	});

	const createPreferenceOrder = async () => {
		if (!loading) {
			loading = true;
			let formData = {
				eventId: membership.eventId,
				membershipTypeId: membership.id
			};
			const res = await fetch(`API_CHECKOUT_URL/preferenceOrders`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					publicKey: publicKey
				},
				body: JSON.stringify(formData)
			});
			const data = await res.json();
			if (data.id) {
				window.location.href = `https://checkout.cobraticket.uy/preference/${data.id}`;
			}
			loading = false;
		}
	};
</script>

{#if membership && membership.id}
	<Button on:click={() => createPreferenceOrder()} {loading}>{!loading ? buttonText : ''}</Button>
{/if}
